export const LOST_TYPE = {
  ADMINISTRATIVE_ERROR: 'administrativeError',
  OPERATIVE_WASTE: 'operativeWaste',
  EXPIRED: 'expired',
  ACCIDENT: 'accident',
  RETURN: 'return'
}
